// Sentry initialization should always be imported at the top to track everything
import './utils/sentry'

import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import moment from 'moment'
import axios from 'axios'
import * as Sentry from '@sentry/react'

// We need to import local storage otherwise it will crash everything
// I think it's because of dependency injection cycle of redux store and local storage
import 'utils/localstorage'

import 'moment/locale/en-gb'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import * as serviceWorker from './serviceWorker'
import App from './App'
import './utils'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-toastify/dist/ReactToastify.css'
import { store, persistor } from './redux/store'
import SentryErrorBoundaryFallback from './components/SentryErrorBoundaryFallback'

moment.locale('en-gb')

window.REACT_APP_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT
window.SEGMENT_KEY = process.env.REACT_APP_SEGMENT_KEY

window.REACT_APP_BASE_IMG_URL = process.env.REACT_APP_BASE_IMG_URL

axios.defaults.baseURL = window.REACT_APP_API_ENDPOINT
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'

axios.interceptors.request.use(
  (reqConfig) => {
    const reqConfigLocal = reqConfig
    const state = store.getState()

    if (state.auth.token) {
      reqConfigLocal.headers.Authorization = `Bearer ${state.auth.token}`
    }

    return reqConfigLocal
  },
  (error) => {
    Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)

// start SEGMENT tracking
if (window.SEGMENT_KEY) {
  const analytics = (window.analytics = window.analytics || [])
  if (!analytics.initialize) {
    if (analytics.invoked) {
      window.console &&
        console.error &&
        console.error('Segment snippet included twice.')
    } else {
      analytics.invoked = !0
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
        'addSourceMiddleware',
        'addIntegrationMiddleware',
        'setAnonymousId',
        'addDestinationMiddleware',
      ]
      analytics.factory = (e) => {
        return () => {
          const t = []
          t.unshift(e)
          analytics.push(t)

          return analytics
        }
      }
      for (let e = 0; e < analytics.methods.length; e++) {
        const key = analytics.methods[e]
        analytics[key] = analytics.factory(key)
      }
      analytics.load = (key, e) => {
        const t = document.createElement('script')
        t.type = 'text/javascript'
        t.async = !0
        t.src = `https://cdn.segment.com/analytics.js/v1/${key}/analytics.min.js`
        const n = document.getElementsByTagName('script')[0]
        n.parentNode.insertBefore(t, n)
        analytics._loadOptions = e
      }
      analytics.SNIPPET_VERSION = '4.13.1'
      analytics.load(window.SEGMENT_KEY)
    }
  }
}
// end SEGMENT tracking

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Sentry.ErrorBoundary fallback={({ error, eventId }) => <SentryErrorBoundaryFallback error={error} eventId={eventId} />}>
        <App />
      </Sentry.ErrorBoundary>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
